import { ApiService } from "../ApiService"

export class VoucherService {

    static uri = '/voucher';

    static get({ params }) {
        return ApiService.get(`${this.uri}`, {
            params,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }
    
    static show({ id }) {
        return ApiService.get(`${this.uri}/show/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static create({ data }) {
        return ApiService.post(`${this.uri}/create`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static generate({ data }) {
        return ApiService.post(`${this.uri}/generate`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static export({ params }) {
        return ApiService.get(`${this.uri}/export`, {
            params,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            },
            responseType: 'blob'
        });
    }

    static import({ file }) {
        const formData = new FormData();
        formData.append('file', file);

        return ApiService.post(`${this.uri}/import`, formData, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            },
        });
    }

    static profileUpdate({ data, id }) {
        return ApiService.post(`${this.uri}/profile-update/${id}`, data);
    }

    static locationUpdate({ id, data }) {
        return ApiService.post(`${this.uri}/location-update/${id}`, data);
    }

    static statusUpdate({ id, data }) {
        return ApiService.post(`${this.uri}/update-status/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }
}